import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "root",
    redirect: "/homeview",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/Login.vue"),
  },
  {
    path: "",
    component: Layout,
    children: [
      {
        path: "/homeview",
        name: "HomeView",
        component: () => import("@/views/HomeView/index.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path === '/homeview') {
    next()
  } else {
    next('/homeview')
  }
  // if (to.path === "/login") {
  //   next();
  // } else {
  //   let token = localStorage.getItem("token");
  //   if (token === null || token === "") {
  //     next("/login");
  //   } else {
  //     next();
  //   }
  // }
});

export default router;
